import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { FaRegCircleUser } from "react-icons/fa6";
import { Link, Outlet, useNavigate, useLocation } from 'react-router-dom';
import ROLE from '../common/role';
import { AiOutlineLoading3Quarters } from 'react-icons/ai'; // Loading spinner
import { AiOutlineMenu, AiOutlineClose } from 'react-icons/ai';

const SalesManPanelPersonalInfo = () => {
  const [loading, setLoading] = useState(true); 
  const user = useSelector(state => state?.user?.user);
  const navigate = useNavigate();
  const location = useLocation(); // Use useLocation hook to get current path
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  useEffect(() => {
    setLoading(true);
    const loadingTimeout = setTimeout(() => {
      
      setLoading(false);
      navigate("/");
    }, 10000); 

    if (user) {
      if (user?.role !== ROLE.SALESMAN) {
        
        navigate("/");
        setLoading(false);
      } 
      else {
        setLoading(false);
        clearTimeout(loadingTimeout)
      }
    } 

    // Clear the timeout when the component unmounts or the effect is rerun
    return () => clearTimeout(loadingTimeout);
  }, [user, navigate]);

  const isActive = (path) => location.pathname === path;

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <AiOutlineLoading3Quarters className="animate-spin text-6xl text-blue-500" />
      </div>
    );
  }

  return (
    <div className='min-h-[calc(100vh-120px)] lg:flex '>
      {/* Mobile Toggle Button */}
      <button onClick={toggleSidebar} className="lg:hidden fixed top-20 left-4 z-50 bg-blue-900 text-white p-2 rounded-full">
        {isSidebarOpen ? <AiOutlineClose size={18} /> : <AiOutlineMenu size={18} />}
      </button>
      {/* Sidebar */}
      <aside className={`lg:block w-full max-w-60 customShadow transition-transform duration-300 ease-in-out
                  ${isSidebarOpen ? 'translate-x-0' : '-translate-x-full'} 
                  fixed lg:relative z-10 bg-white lg:bg-transparent lg:translate-x-0 h-full lg:h-auto top-18`}>

        <div className='h-32 flex justify-center items-center flex-col'>
          <div className='text-5xl cursor-pointer relative flex justify-center'>
            {
              user?.profilePic ? (
                <img src={user?.profilePic} className='w-20 h-20 rounded-full' alt={user?.name} />
              ) : (
                <FaRegCircleUser />
              )
            }
          </div>
          <p className='capitalize text-lg font-semibold'>{user?.name}</p>
          <p className='text-sm'>{user?.type =='Medicine'? ' مندوب مبيعات شركة دواكو' : ' مندوب مبيعات شركة مستحضرات التجميل'}</p>
        </div>

        {/***navigation */}
        <div className='p-4'>
          {/* Admin Info Section */}
          <div className='mb-4'>
            <h2 className='text-xl font-semibold mb-2 text-center'>المعلومات الشخصية</h2>
            <nav className='grid'>
              <Link to={"salesManProfile"} className={`px-2 py-1 ${isActive('/SalesManPanelPersonalInfo/salesManProfile') ? 'bg-slate-200 font-bold' : 'hover:bg-slate-100'} text-right`}>
                الملف الشخصي
              </Link>
              <Link to={"salesManEditProfile"} className={`px-2 py-1 ${isActive('/SalesManPanelPersonalInfo/salesManEditProfile') ? 'bg-slate-200 font-bold' : 'hover:bg-slate-100'} text-right`}>
              تعديل الملف الشخصي
              </Link>
              <Link to={"salesManChangePassword"} className={`px-2 py-1 ${isActive('/SalesManPanelPersonalInfo/salesManChangePassword') ? 'bg-slate-200 font-bold' : 'hover:bg-slate-100'} text-right`}>
              تغيير كلمة المرور
              </Link>
            </nav>
          </div>

         
        </div>
      </aside>

      <main className={`w-full h-full p-2 ${isSidebarOpen ? 'opacity-50 pointer-events-none' : 'opacity-100'}`}>
        <Outlet />
      </main>
    </div>
  );
}

export default SalesManPanelPersonalInfo;
